






























































































































































































import { Component, Vue } from "vue-property-decorator";
import LoaderFadeOut from "@/components/LoaderFadeOut.vue";

@Component({
  components: {
    LoaderFadeOut,
  },
})
export default class PageServices extends Vue {
  public mounted() {
    $(".parallax-mirror").hide();
  }
}
